import script from "./MainSiteLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./MainSiteLogo.vue?vue&type=script&setup=true&lang=js"

import "./MainSiteLogo.vue?vue&type=style&index=0&id=bb2e42dc&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb2e42dc"]])

export default __exports__